'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _restaurantsFoursquareProxyClient = require('@wix/restaurants-foursquare-proxy-client');

exports.default = function (path, params) {
    var foursquareApi = new _restaurantsFoursquareProxyClient.FoursquareProxyClient({ XMLHttpRequest: XMLHttpRequest });

    params.v = '20160501';

    return foursquareApi.api({ path: path, params: params });
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/FoursquareApiConnector.js
// module id = 983
// module chunks = 0